/**
 * streamUrl — build the video stream URL routed through the Night Light
 * CORS relay so the browser allows WebGL texture upload.
 *
 * Constitutional (Principle III, v1.0.1 CORS relay exception): the relay
 * adds Access-Control-Allow-Origin headers without caching, storing, or
 * inspecting the video content. The upstream host MUST be *.archive.org.
 */

import type { MetadataFile, MetadataResponse } from "../../types.ts";

const PROXY_BASE: string =
  (import.meta.env?.VITE_PROXY_BASE as string | undefined) ??
  "http://localhost:8787";

export function streamUrl(metadata: MetadataResponse, file: MetadataFile): string {
  const host = metadata.server.replace(/\/+$/, "");
  const dir = metadata.dir.startsWith("/") ? metadata.dir : `/${metadata.dir}`;
  const name = encodeURIComponent(file.name);
  return `${PROXY_BASE}/stream/${host}${dir}/${name}`;
}
